import * as React from 'react';
export const SvgAlarmPriority1 = (props) => {
    return (React.createElement("svg", { viewBox: '0 0 16 16', width: '1rem', height: '1rem', ...props },
        React.createElement("path", { d: 'M8 .5L15.5 8 8 15.5.5 8z', fill: '#ed1c24' }),
        React.createElement("path", { d: 'M8 1.414L14.586 8 8 14.586 1.414 8zM8 0L0 8l8 8 8-8z' }),
        React.createElement("path", { d: 'M9.191 11.332H7.783V7.476l.014-.634.023-.692a6.998 6.998 0 01-.488.46l-.766.615-.678-.848 2.146-1.709h1.157z', fill: '#fff' })));
};
export default SvgAlarmPriority1;
